import { render } from "./FileDropArea.vue?vue&type=template&id=33598710&scoped=true"
import script from "./FileDropArea.vue?vue&type=script&lang=js"
export * from "./FileDropArea.vue?vue&type=script&lang=js"

import "./FileDropArea.vue?vue&type=style&index=0&id=33598710&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33598710"]])

export default __exports__